import * as Yup from 'yup';
import { emailRegEx, phoneRegEx, zipCodeRegEx } from '@/utils/RegularExpressions';
import { States } from '../../../../../constants';
import { defaultStepsSchema } from '../../Components/DefaultApplicantInformation/validationSchema';

export const validStateOptions: string[] = States.map((state) => state.name);

export const boolean = ['Yes', 'No'];
export const clientType = ['Resident Investor', 'Community Developers', 'CDCs'];

const step1Schema = Yup.object({
  step1: Yup.object({
    section1: Yup.object({
      name: Yup.string().required('Required').min(2, 'It must be greater than 2 character'),
      dob: Yup.string().required('Required'),
      race: Yup.string().required('Required'),
      phone: Yup.string().required('Required').matches(phoneRegEx, {
        excludeEmptyString: true,
        message: 'Please enter a valid phone number',
      }),
      email: Yup.string().required('Required').matches(emailRegEx, {
        excludeEmptyString: true,
        message: 'Please enter a valid email address',
      }),

      clientType: Yup.string().required('Required').oneOf(clientType, 'Invalid option'),
    }),
    section2: Yup.object({
      streetAddress: Yup.string().required('Required'),
      city: Yup.string().required('Required'),
      state: Yup.string().required('Required').oneOf(validStateOptions, 'Invalid option'),
      zipCode: Yup.string()
        .required('Required')
        .matches(zipCodeRegEx, 'It must be 5 digits')
        .max(5, 'It must be 5 digits')
        .min(5, 'It must be 5 digits'),
      rentStatus: Yup.string().required('Required'),
      lengthInYears: Yup.string().required('Required').max(2, 'It must be less than 100'),
      codeViolation: Yup.string().required('Required'),
    }),
    section3: Yup.object({
      propertyTaxes: Yup.string().required('Required'),
      waterBills: Yup.string().required('Required'),
      sewageBills: Yup.string().required('Required'),
      refuseBills: Yup.string().required('Required'),
    }),
    section5: Yup.object({
      q1: Yup.string().required('Required'),
      projectFinancialReadiness: Yup.string().required('Required'),
      understandProcess: Yup.string().required('Required'),
    }),
    section6: Yup.object({
      financialReadiness: Yup.string().required('Required'),
      communitySupport: Yup.string().required('Required'),
    }),
  }),
});

const step2Schema = Yup.object({
  step2: Yup.object({
    q1: Yup.string().required('Required'),
    'q1-interestedPropertyDetail': Yup.string().when('q1', {
      is: 'no',
      then: (schema) => schema.required('Required').max(250, 'Must be less than 250 characters'),
      otherwise: (schema) => schema.nullable(),
    }),
    q2: Yup.string().required('Required'),
  }),
});

export const GStrategiesValidationSchema = [defaultStepsSchema, step1Schema, step2Schema];
